<template>
    <div class="your-vehicle bg-white d-flex my-3 mb-3 mb-sm-4">
        <div class="d-flex flex-column flex-lg-row align-items-lg-center gap-1 gap-lg-2">
            <b class="fs-5 text-navy">Your Vehicle</b>
            <div class="d-flex align-items-center gap-2 reg-form-mobile">
                <span class="mx-lg-2">Registration: </span>
                <reg-form-custom :postcode="postcode" :reg="registration" :image-base-path="imageBasePath"></reg-form-custom>
            </div>
            <template v-if="make || model">
                <p class="d-inline-block mt-2 mt-lg-0 ms-0 ms-lg-3 mb-0"><span class="fw-bold">Model:</span> <span class="d-inline-block">{{ make }} {{  model }} {{ colour  ? '- ' + colour : ''}}</span></p>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['registration', 'make', 'model', 'colour', 'postcode', 'sizeOptions', 'imageBasePath'],
        data() {
	        return {
                vehicleRegistration: this.registration,
                vehicleMake: this.make,
                vehicleModel: this.model,
	        }
	    },
	    mounted() {
            let vm = this;
            // if no props, do axios request
            if(vm.registration == null || vm.make == null || vm.model) {
                axios.get('/ajax/get_vehicle').then(function(response) {
                    vm.vehicleRegistration = response.data.registration
                    vm.vehicleMake = response.data.make
                    vm.vehicleModel = response.data.model
                });
            }
	    },
	    methods: {
            async updateRegistration() {
                this.emitter.emit('isLoading', true);
                let response = await axios.post('/update-registration', {registration: this.vehicleRegistration});

                console.log(response);
                this.emitter.emit('isLoading', false);
            }
	    },
	    computed: {
           
	    }
    }
</script>

<style lang="scss" scoped>
    .your-vehicle {
        .reg-input {
            border: 0;
            padding: 5px 0;
            border-radius: 6px;
            background-color: #fc3 !important;
            text-align: center;
            color: black;
            font-weight: bold;
            font-size: 16px;
            text-transform: uppercase;
            margin-left: 10px;
            width: 110px;
            &::placeholder {
                color: #383838;
            }
        }
    }
    hr {
        height: 2px;
        width: 100%;
    }
    @media screen and (max-width: 411px) {
        .reg-form-mobile {
            flex-direction: column;
            align-items: unset !important;
            flex-wrap: wrap;
        }
    }
</style>